<template>
  <el-dialog
      :visible="isVisible"
      @close="hide"
      :destroy-on-close="true"
      width="70%"
  >
    <template slot="title">
      <span class="text-uppercase">
        Security groups: <span class="font-weight-bold">{{ name }}</span>
      </span>
    </template>
    <index-component
        :index-url="url"
    ></index-component>
  </el-dialog>
</template>

<script>
import eventBus from "../../../../event-bus";
import IndexComponent from './index';


export default {
  components: {
    IndexComponent,
  },

  data() {
    return {
      url: null,
      name: null
    };
  },

  computed: {
    /**
     * @return {boolean}
     */
    isVisible() {
      return Boolean(this.url);
    },
  },

  methods: {
    /**
     * @param {string} url
     * @param {string} name
     */
    show({url, name}) {
      this.url = url;
      this.name = name;
    },

    /**
     * @return {undefined}
     */
    hide() {
      this.url = null;
      this.name = null;
    },
  },

  created() {
    eventBus.$on('show-assign-user-groups-dialog', this.show);
  },

  beforeDestroy() {
    eventBus.$off('show-assign-user-groups-dialog', this.show);
  }
}
</script>

<style scoped>
  /deep/ .el-dialog__body {
    padding-top: 10px;
  }
</style>
